import '@nordhealth/components'

export default defineNuxtPlugin(() => {})
